import angular from 'angular';
import messageEditComponent from './message-edit.component';

export default angular.module('components.app.dashboard.message-edit', [])
  .component('messageEdit', messageEditComponent)
  .value('EventEmitter', payload => ({ $event: payload }))
  .name;



// WEBPACK FOOTER //
// ./components/app/dashboard/message-edit/message-edit.module.js